import type { TCalendlyStep } from './releaseAndNotify';

import { COMPLETED_ENDING } from '@/constants/interviewCall';
import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';

type TCompleteVariables = {
  bookingID: string;
};

type TInterviewCompletion = {
  calendly: TCalendlyStep;
};

const completeAndCancel = async ({ bookingID }: TCompleteVariables): Promise<TInterviewCompletion> => {
  errorUtils.unwrap(await interviewsService.completeInterview(bookingID));

  const result = await interviewsService.cancelEvent(bookingID, COMPLETED_ENDING);

  if (errorUtils.isNetworkError(result)) {
    return { calendly: 'failed' };
  }

  return { calendly: result };
};

export type {
  TCompleteVariables,
  TInterviewCompletion,
};
export {
  completeAndCancel,
};
